define('shared/initializer/form/adapters/mixins/fields/EFECCity',[
    '$',
    '../../../constants',
    'shared/lib/RSVP',
    'shared/page/market',
    'shared/lib/console',
    'shared/util/Domain',
    'shared/util/efec/relocator',
    'shared/page/city'
], function (
    $,
    constants, 
    RSVP,
    getMarket,
    console,
    Domain,
    relocator,
    getCity
) {
    'use strict';

    function Ctor() {

    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        var currentDomain = new Domain(window.location.hostname);
        var fieldCity = me.items[constants.FIELD.CITY];

        return RSVP.all([getMarket(), getCity()])
            .then(function(values){
                var marketCode = values[0];
                var cityCode = values[1];

                if(
                    currentDomain.is.subOf(Domain.englishCenters) === false ||
                    fieldCity == null || 
                    marketCode !== 'es'
                ){
                    return RSVP.resolve();
                }

                fieldCity.$el.val(cityCode || '');
                fieldCity.$el.change(function(){
                    var selectedCityCode = fieldCity.$el.val();
                    if (selectedCityCode == null || $.trim(selectedCityCode) === '') {
                        return;
                    }

                    relocator
                        .process(selectedCityCode)
                        .then(function(url){
                            if (url == null) {
                                return;
                            }
                            window.location.href = url;
                        });
                });

                return RSVP.resolve();
            });
    };

    return Ctor;
});
